import React, { useState } from "react";
import { Modal, Input, message } from "antd";
import { addSubtopic } from "../../../services/polly/classificationService";

export default function AddSubtopicModal({ visible, parentTopic, onCancel, onSuccess }) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAdd = async () => {
    if (!name.trim()) {
      message.error("Topic name is required");
      return;
    }
    setLoading(true);
    try {
      await addSubtopic(name.trim(), parentTopic.id);
      setName("");
      onSuccess();
    } catch (err) {
      console.warn("Failed to add subtopic:", err);
      message.error("Failed to add subtopic");
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setName("");
    onCancel();
  };

  return (
    <Modal
      title="Add Subtopic"
      visible={visible}
      onOk={handleAdd}
      onCancel={handleCancel}
      okText="Add"
      confirmLoading={loading}
      okButtonProps={{ disabled: loading }}
    >
      {parentTopic && (
        <p style={{ color: "#888", marginBottom: 12, fontSize: 13 }}>
          Adding subtopic under: <strong>{parentTopic.name}</strong>
        </p>
      )}
      <Input
        placeholder="Topic name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onPressEnter={handleAdd}
        disabled={loading}
        autoFocus
      />
    </Modal>
  );
}
